"use client";

/**
 * Kakao OAuth 유틸리티 (REST API 리다이렉트 방식)
 *
 * SDK v2에서 Auth.login() 제거로 인해 REST API 직접 호출 방식 사용.
 * 1. authorizeKakao() — kauth.kakao.com으로 OAuth 리다이렉트
 * 2. 콜백 처리는 /oauth/kakao 페이지 + /api/oauth/kakao API route
 *
 * shared 레이어: config, workspace-pkg만 import 가능
 */
const KAKAO_REST_KEY = process.env["NEXT_PUBLIC_KAKAO_REST_KEY"] ?? "";
const KAKAO_REDIRECT_URI = process.env["NEXT_PUBLIC_KAKAO_REDIRECT_URI"] ?? "";

/**
 * Kakao OAuth 인증 리다이렉트
 *
 * REST API 키로 직접 OAuth authorize URL을 구성하여 리다이렉트.
 * CSRF 방지를 위해 state 파라미터를 생성하고 sessionStorage에 저장한다.
 */
export function authorizeKakao(): void {
  const state = crypto.randomUUID();
  sessionStorage.setItem("kakao_oauth_state", state);

  const params = new URLSearchParams({
    client_id: KAKAO_REST_KEY,
    redirect_uri: KAKAO_REDIRECT_URI,
    response_type: "code",
    state,
  });

  window.location.href = `https://kauth.kakao.com/oauth/authorize?${params}`;
}

/**
 * OAuth state 검증
 *
 * 콜백 페이지에서 state 파라미터를 검증하여 CSRF 공격을 방지한다.
 */
export function verifyOAuthState(state: string | null): boolean {
  const saved = sessionStorage.getItem("kakao_oauth_state");
  sessionStorage.removeItem("kakao_oauth_state");
  return !!state && !!saved && state === saved;
}
